/**
 * One-time Telegram Mini App SDK initialization.
 *
 * Call {@link initTelegram} once at app bootstrap (before rendering) so that
 * component-level signals (BackButton, MainButton, theme, viewport) are mounted
 * and reactive.
 */
import {
  backButton,
  init as sdkInit,
  mainButton,
  miniApp,
  themeParams,
  viewport,
} from "@telegram-apps/sdk-react";

let initialized = false;

/**
 * Initialize the SDK and mount the commonly used components.
 *
 * Idempotent: safe to call more than once. Outside the Telegram environment the
 * mounts are skipped silently so the app can still render (e.g. in a browser or
 * test runner).
 *
 * @returns ``true`` when running inside Telegram and fully mounted, else ``false``.
 */
export function initTelegram(): boolean {
  if (initialized) {
    return true;
  }

  try {
    sdkInit();

    if (miniApp.mount.isAvailable()) {
      miniApp.mount();
    }
    if (themeParams.mount.isAvailable()) {
      themeParams.mount();
    }
    if (backButton.mount.isAvailable()) {
      backButton.mount();
    }
    if (mainButton.mount.isAvailable()) {
      mainButton.mount();
    }
    if (viewport.mount.isAvailable()) {
      void viewport.mount();
    }

    initialized = true;
    return true;
  } catch {
    return false;
  }
}
